import { sei, seiTestnet } from 'viem/chains';

const isTestnet = import.meta.env.VITE_IS_TESTNET === 'true';

export const getNetworkConfig = () => {
  if (isTestnet) {
    return {
      chain: seiTestnet,
      chainId: seiTestnet.id,
      rpcUrl: seiTestnet.rpcUrls.default.http[0],
      networkName: 'Sei Testnet',
      blockExplorerUrl: 'https://seitrace.com/',
    };
  } else {
    return {
      chain: sei,
      chainId: sei.id,
      rpcUrl: sei.rpcUrls.default.http[0],
      networkName: 'Sei Mainnet',
      blockExplorerUrl: 'https://seitrace.com/',
    };
  }
};

export const NETWORK_CONFIG = getNetworkConfig();
